import React from 'react'

import { Link } from 'react-router-dom'
import { Row, Col, Avatar, Divider, Card, Badge } from 'antd'

import {
  LAYOUT_ADMIN_CONFIG_INFORMATION,
  LAYOUT_ADMIN_CONFIG_SETTING_FORM,
  LAYOUT_ADMIN_MANAGER_ROOT,
  LAYOUT_ADMIN_USER_ROOT,
  LAYOUT_ADMIN_UNIT_ROOT,
  LAYOUT_ADMIN_SERVICE_ROOT,
  LAYOUT_ADMIN_SPECIALIZATION_ROOT,
  LAYOUT_ADMIN_LANGUAGE_PAIR_ROOT,
  LAYOUT_ADMIN_LANGUAGE_ROOT,
  LAYOUT_ADMIN_COUNTRY_ROOT,
  LAYOUT_ADMIN_CAMPAIGN_ROOT,
  LAYOUT_ADMIN_NOTIFICATION_GROUP_ROOT,
  LAYOUT_ADMIN_BRAND_FORM,
  LAYOUT_ADMIN_THEME_FORM,
  LAYOUT_ADMIN_SMTP_FORM,
  LAYOUT_ADMIN_MAIL_QUEUE_LIST,
  LAYOUT_ADMIN_TAG_LIST,
  LAYOUT_ADMIN_PRIORITY_LIST,
  LAYOUT_ADMIN_WORKING_HOURS_FORM,
  LAYOUT_ADMIN_TEMPLATE_FOLDER_ROOT,
  LAYOUT_ADMIN_STORAGE_ROOT
} from '../navigation'

const { Meta } = Card

const ManagersIcon = require('../../../assets/icons/managers.png')
const UsersIcon = require('../../../assets/icons/users.png')
const ServicesIcon = require('../../../assets/icons/services.png')
const LanguageIcon = require('../../../assets/icons/language.png')
const LanguagePairsIcon = require('../../../assets/icons/language-pairs.png')
const UnitsIcon = require('../../../assets/icons/units.png')
const CountriesIcon = require('../../../assets/icons/countries.png')
const TemplatesIcon = require('../../../assets/icons/templates.png')
const NotificationIcon = require('../../../assets/icons/notification.png')
const ThemeIcon = require('../../../assets/icons/theme.png')
const BrandIcon = require('../../../assets/icons/brand.png')
const StorageIcon = require('../../../assets/icons/box.png')
const TemplateFolderIcon = require('../../../assets/icons/box.png')
const EmailsIcon = require('../../../assets/icons/emails.png')
const CampaignsIcon = require('../../../assets/icons/campaigns.png')
const TagsIcon = require('../../../assets/icons/tags.png')
const PrioritiesIcon = require('../../../assets/icons/priorities.png')
const SpecializationIcon = require('../../../assets/icons/specialization.png')
const WorkingHoursIcon = require('../../../assets/icons/working-hours.png')
const InformationIcon = require('../../../assets/icons/information.png')

const Panel = () => (
  <>
    <Divider />

    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ marginLeft: 0, marginRight: 0 }}>
      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_MANAGER_ROOT}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={ManagersIcon} shape='square' />}
              title='Managers'
              description='Administration'
            />
          </Card>
        </Link>
      </Col>

      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_SERVICE_ROOT}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={ServicesIcon} shape='square' />}
              title='Services'
              description='Administration'
            />
          </Card>
        </Link>
      </Col>

      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_LANGUAGE_PAIR_ROOT}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={LanguagePairsIcon} shape='square' />}
              title='Language Pairs'
              description='Administration'
            />
          </Card>
        </Link>
      </Col>

      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_LANGUAGE_ROOT}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={LanguageIcon} shape='square' />}
              title='Languages'
              description='Administration'
            />
          </Card>
        </Link>
      </Col>

      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_UNIT_ROOT}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={UnitsIcon} shape='square' />}
              title='Units'
              description='Administration'
            />
          </Card>
        </Link>
      </Col>

      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_COUNTRY_ROOT}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={CountriesIcon} shape='square' />}
              title='Countries'
              description='Administration'
            />
          </Card>
        </Link>
      </Col>

      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_SPECIALIZATION_ROOT}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={SpecializationIcon} shape='square' />}
              title='Specializations'
              description='Administration'
            />
          </Card>
        </Link>
      </Col>

      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_NOTIFICATION_GROUP_ROOT}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={NotificationIcon} shape='square' />}
              title='Notification'
              description='Administration'
            />
          </Card>
        </Link>
      </Col>
      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_TAG_LIST}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={TagsIcon} shape='square' />}
              title='Tag'
              description='Administration'
            />
          </Card>
        </Link>
      </Col>
      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_PRIORITY_LIST}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={PrioritiesIcon} shape='square' />}
              title='Priority'
              description='Administration'
            />
          </Card>
        </Link>
      </Col>

      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_CAMPAIGN_ROOT}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={CampaignsIcon} shape='square' />}
              title='Campaigns'
              description='Administration'
            />
          </Card>
        </Link>
      </Col>
      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_TEMPLATE_FOLDER_ROOT}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={TemplateFolderIcon} shape='square' />}
              title='Template Folders'
              description='Administration'
            />
          </Card>
        </Link>
      </Col>
    </Row>

    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ marginLeft: 0, marginRight: 0 }}>
      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_USER_ROOT}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={UsersIcon} shape='square' />}
              title='Users'
              description='Administration'
            />
          </Card>
        </Link>
      </Col>
    </Row>

    <Divider />

    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ marginLeft: 0, marginRight: 0 }}>
      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_BRAND_FORM}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={BrandIcon} shape='square' />}
              title='Branding'
              description='Configuration'
            />
          </Card>
        </Link>
      </Col>
      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_WORKING_HOURS_FORM}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={WorkingHoursIcon} shape='square' />}
              title='Working Hours'
              description='Configuration'
            />
          </Card>
        </Link>
      </Col>

      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_THEME_FORM}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={ThemeIcon} shape='square' />}
              title='Theme'
              description='Configuration'
            />
          </Card>
        </Link>
      </Col>

      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_SMTP_FORM}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={EmailsIcon} shape='square' />}
              title='SMTP'
              description='Configuration'
            />
          </Card>
        </Link>
      </Col>

      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_STORAGE_ROOT}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={StorageIcon} shape='square' />}
              title='Storage'
              description='Configuration'
            />
          </Card>
        </Link>
      </Col>

      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_CONFIG_SETTING_FORM}>
          <Badge.Ribbon text='Deprecated!' color='grey'>
            <Card style={{ marginTop: 16 }} hoverable>
              <Meta
                avatar={<Avatar size='large' src={StorageIcon} shape='square' />}
                title='Storage Box'
                description='Configuration'
              />
            </Card>
          </Badge.Ribbon>
        </Link>
      </Col>

      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_MAIL_QUEUE_LIST}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={EmailsIcon} shape='square' />}
              title='Mail Queue'
              description='Configuration'
            />
          </Card>
        </Link>
      </Col>
    </Row>

    <Divider />

    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ marginLeft: 0, marginRight: 0 }}>
      <Col className='gutter-row' xs={24} md={12} lg={8} xl={6}>
        <Link to={LAYOUT_ADMIN_CONFIG_INFORMATION}>
          <Card style={{ marginTop: 16 }} hoverable>
            <Meta
              avatar={<Avatar size='large' src={InformationIcon} shape='square' />}
              title='Version'
              description='Information'
            />
          </Card>
        </Link>
      </Col>
    </Row>
  </>
)

export default Panel
